import { Check, Minus } from "lucide-react";
import Section from "@/components/site/Section";
import { Reveal } from "@/components/site/Reveal";
import { SectionHeading } from "@/components/site/primitives";
import { COMPARISON } from "@/lib/content";

export default function Comparison() {
  return (
    <Section data-testid="comparison">
      <Reveal className="max-w-3xl">
        <SectionHeading overline="Why RestPower" title={<>The roadside stop,<br />upgraded.</>} />
        <p className="mt-6 text-base leading-relaxed text-white/55">
          A neutral look at how the RestPower concept compares to a typical charging stop today.
        </p>
      </Reveal>

      <Reveal delay={0.06} className="mt-12 overflow-hidden rounded-2xl border border-white/10">
        {/* header */}
        <div className="grid grid-cols-3 border-b border-white/10 bg-rp-surface">
          <div className="p-4 font-mono text-[10px] uppercase tracking-[0.14em] text-white/40 md:p-5 md:text-xs">Feature</div>
          <div className="border-l border-white/10 bg-rp-accent/5 p-4 font-mono text-[10px] uppercase tracking-[0.14em] text-rp-accent md:p-5 md:text-xs">RestPower Concept</div>
          <div className="border-l border-white/10 p-4 font-mono text-[10px] uppercase tracking-[0.14em] text-white/40 md:p-5 md:text-xs">Traditional Stop</div>
        </div>
        {COMPARISON.map((r, i) => (
          <div key={r.row} className={`grid grid-cols-3 ${i % 2 ? "bg-rp-card" : "bg-rp-bg"}`}>
            <div className="flex items-center p-4 text-xs font-medium text-white/70 md:p-5 md:text-sm">{r.row}</div>
            <div className="flex items-start gap-2 border-l border-white/10 bg-rp-accent/5 p-4 text-xs text-white/80 md:p-5 md:text-sm">
              <Check className="mt-0.5 h-4 w-4 flex-shrink-0 text-rp-accent" /> <span>{r.rp}</span>
            </div>
            <div className="flex items-start gap-2 border-l border-white/10 p-4 text-xs text-white/50 md:p-5 md:text-sm">
              <Minus className="mt-0.5 h-4 w-4 flex-shrink-0 text-white/25" /> <span>{r.trad}</span>
            </div>
          </div>
        ))}
      </Reveal>
    </Section>
  );
}
